import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as SuccessIcon } from '../../public/images/svg/icon_checkmark_similarity_green.svg';
import { ReactComponent as FailedIcon } from '../../public/images/svg/icon_checkmark_similarity_red.svg';
import { ReactComponent as WarningIcon } from '../../public/images/svg/icon_checkmark_similarity_yellow.svg';
import { ReactComponent as InprogressSmIcon } from '../../public/images/svg/icon_inprogress_sm.svg';
import { ReactComponent as SuccessSmIcon } from '../../public/images/svg/icon_success_sm.svg';
import { ReactComponent as FailedSmIcon } from '../../public/images/svg/icon_failure_sm.svg';
import { ReactComponent as WarningSmIcon } from '../../public/images/svg/icon_warn_sm.svg';

export const Status = {
  inprogress: 'inprogress',
  success: 'success',
  needsattention: 'needsattention',
  failed: 'failed'
};

const renderIcon = (status, size) => {
  switch (status) {
    case Status.inprogress:
      return size === 'small' ? (
        <InprogressSmIcon />
      ) : (
        <i style={{ display: 'block' }} className="material-icons text-gray-600">
          schedule
        </i>
      );
    case Status.success:
      return size === 'small' ? <SuccessSmIcon /> : <SuccessIcon />;
    case Status.needsattention:
      return size === 'small' ? <WarningSmIcon /> : <WarningIcon />;
    case Status.failed:
      return size === 'small' ? <FailedSmIcon /> : <FailedIcon />;
    default:
      return null;
  }
};

const StatusIcon = ({ status, size = 'default', className = '', dataTest }) => {
  return (
    <div className={`status-icon inline-block ${className}`} data-testid={dataTest}>
      {renderIcon(status, size)}
    </div>
  );
};

StatusIcon.propTypes = {
  status: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  dataTest: PropTypes.string
};

export default StatusIcon;
